import { AnySourceStream, Stream } from '../stream'

export class Pass<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> extends Stream<SV, SE, SC, DV, DE, DC> {
    constructor(protected source?: AnySourceStream<SV, SE, SC>) {
        super()
    }

    connect() {
        super.connect()
        if (this.source) this.source.subscribe(this)
    }

    disconnect() {
        super.disconnect()
        if (this.source) this.source.unsubscribe(this)
    }
}
